import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch } from '../../../app/hooks';
import { number } from 'yup';
import {
    getAccountPayRuleDatatableAsync, checkedState, unCheckedState, checkedAllState, unCheckedAllState, deletePayRuleAsync,
    getPayRuleDataByAccountPayRuleIdAsync, getPayRuleDetailByAccountPayRuleIdAsync, updatePayRuleAsync
} from './payRuleSlice';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import { ShowToast } from '../../../common/Toastr';
import clsx from 'clsx';

const itemClass = 'ms-1 ms-lg-0';
const PayRuleItem = (props: any) => {
    const { payRuleList, payCodeDetail, t, IsEdit, IsDelete } = props;
    const dispatch = useAppDispatch();

    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };

    const onEditClick = (AccountPayRuleId: number) => {
        dispatch(getPayRuleDetailByAccountPayRuleIdAsync(AccountPayRuleId));
    }

    const onDeleteClick = (AccountPayRuleId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deletePayRuleAsync(AccountPayRuleId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Pay Rule Deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                        })
                }
            })
            .catch((error) => {
            });
    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };

    const handleIsDisabledChange = (e: any, payRule: any) => {
        const { checked } = e.target;
        const foundIndex = payRuleList.findIndex((item: any) => item.AccountPayRuleId === payRule.AccountPayRuleId);
        if (foundIndex !== -1) {
            const foundItem = payRuleList[foundIndex];
            const { isSelected, ...updatedItem } = foundItem;
            updatedItem.IsDisabled = checked;
            const modifiedList = [...payRuleList.slice(0, foundIndex), updatedItem, ...payRuleList.slice(foundIndex + 1)];
            dispatch(updatePayRuleAsync(updatedItem))
        }
    }

    return (
        <>
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle "  >
                        {IsDelete &&
                            <th className='w-25px'>
                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                    <input
                                        className='form-check-input'
                                        type='checkbox'
                                        checked={payRuleList.every((item: any) => item.isSelected === 0) ? false :
                                            (payRuleList.every((item: any) => item.isSelected === 1 ? true : false))
                                        }
                                        onChange={handleSelectAllChange}
                                    />
                                </div>
                            </th>
                        }
                        <th className='w-75'>{t('Pay Rule')}</th>
                        {IsEdit &&
                            <th className='w-15'>{t('Active / Inactive')}</th>
                        }
                        <th className='w-10 text-center'></th>
                    </tr>
                </thead>
                <tbody>
                    {payRuleList.length === 0 && <tr><td colSpan={3}><p className='noDataFound'>{t('No Record Found')}</p></td></tr>}
                    {payRuleList.length > 0 && payRuleList.map((payRuleDetail: any, i: any) => (
                        <tr key={i}>
                            {IsDelete &&
                                <td>
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                        <input
                                            type="checkbox"
                                            className="form-check-input widget-9-check"
                                            checked={payRuleDetail.isSelected == 0 ? false : true}
                                            onChange={(e) => { handleCheckboxChange(e, payRuleDetail.AccountPayRuleId) }}
                                        />
                                    </div>
                                </td>
                            }
                            <td id={`${IsEdit ? 'kt_OffCanvas' : ''}`} className='text-gray-800  text-hover-primary custom-pointer-cursor '
                                onClick={IsEdit ? () => onEditClick(payRuleDetail.AccountPayRuleId) : undefined}
                            >
                                <span className="d-block">
                                    {payRuleDetail.AccountPayRuleName}
                                </span>
                            </td>
                            {IsEdit &&
                                <td className='text-center'>
                                    <div className="form-check form-switch form-check-custom">
                                        <input
                                            type="checkbox"
                                            className="form-check-input custom-padding-right h-15px w-30px"
                                            id="IsDisabled"
                                            checked={payRuleDetail.IsDisabled}
                                            onChange={(e) => { handleIsDisabledChange(e, payRuleDetail) }}
                                        />
                                    </div>
                                </td>
                            }
                            <td className='text-center' >
                                <div className={clsx('app-navbar-item', itemClass)}>
                                    <Dropdown
                                        style={{ marginLeft: 1 }}
                                        className={clsx('cursor-pointer symbol')}
                                        data-kt-menu-attach='parent'
                                        data-kt-menu-placement='bottom-end'
                                    >
                                        <Dropdown.Toggle
                                            variant="transparent"
                                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                            data-tooltip-id="tooltip-Description"
                                            data-tooltip-content={"More"}
                                            data-tooltip-place="bottom"
                                        >
                                            <i className="bi bi-three-dots fs-7 " ></i>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu
                                            className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1   py-1 fs-7 w-150px'>
                                            {IsEdit &&
                                                <>
                                                    <div className='menu-hover-bg-sec'>
                                                        <Dropdown.Item
                                                            id="kt_OffCanvas"
                                                            className="menu-item me-lg-0 "
                                                            onClick={() => onEditClick(payRuleDetail.AccountPayRuleId)}
                                                        >
                                                            <span className="menu-icon custom-menu">
                                                                <i className="bi bi-pencil fs-6  iconColor allign">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title custom-menu-fontsize">{`${t('Edit')}`}</span>
                                                        </Dropdown.Item>
                                                    </div>
                                                </>
                                            }
                                            {IsDelete && IsEdit &&
                                                <div className='separator mb-1 mt-1 opacity-75 '></div>
                                            }
                                            {IsDelete &&
                                                <>
                                                    <div className='menu-hover-bg-danger'>
                                                        <Dropdown.Item
                                                            className="menu-item me-lg-0 "
                                                            onClick={() => { onDeleteClick(payRuleDetail.AccountPayRuleId) }}
                                                        >
                                                            <span className="menu-icon  custom-menu">
                                                                <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title   delete-menu custom-menu-fontsize"  >{`${t('Delete')}`}</span>
                                                        </Dropdown.Item>
                                                    </div>
                                                </>
                                            }
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

        </>
    )
}

export default PayRuleItem


